export default __webpack_public_path__ + "static/media/mainbanneri.fd56b046.png";